import React from "react";
import { FormField } from "../form_components";
import Input from "../form_components/Input";
import Textarea from "../form_components/Textarea";
import ItemList from "../form_components/ItemList";
import Condition from "../form_components/Condition";
import Button from "../form_components/Button";
import KeyValue from "../form_components/KeyValue";
import Switch from "../form_components/Switch";
import Dropdown from "../form_components/Dropdown";
import ModuleNodeModel from "../models/ModuleNodeModel";
import { ErrorMessageType } from "../services";
import BasicSlider from "../form_components/BasicSlider";
import KeySwitch from "../form_components/KeySwitch";
import GroupPermission from "../form_components/GroupPermission";
import FunctionComponent from "../form_components/Function";
import { Constant } from '../const';
import ScopeHint from "../form_components/ScopeHint";
import TagList from "../form_components/TagList";
import PromptTextarea from "../form_components/PromptTextarea";
import { IntentDropdown } from "../form_components/IntentDropdown";
import ExitComponent from "../form_components/ExitComponent";
import VisibilityWrapper from "../form_components/VisibilityWrapper";
import UserTypeStorage from "../utilities/UserTypeStorage";
import { defaultServiceContext } from "../contexts";
import NestedProperties from "../form_components/NestedProperties";
import { ConfigViewType } from "../types";
import { formatTimeSince, getModelIcon } from "../utilities";
import Utility from "../utilities/Utility";
import { ClickOutside } from "../utilities/components";

const {
    avsService,
    errorMessageService
} = defaultServiceContext;

const scrollContainerId = 'property_panel_props';

export default class PropertyPanelWidget extends React.Component {
    /**
     * Property panel
     * @module PropertyPanelWidget
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            shouldHover: false,
            commonModuleVersionsOptions: [{ name: 'Loading...', value: 'Loading...' }],
            commonModuleSelectedVersion: 0,
            userType: UserTypeStorage.getUserType(),
            formsList: {},
            uniqueFormsList: [{name: 'Loading...', value: 'Loading...'}],
            scrollPosition: 0,
            saveScrollPosition: true,
        }

        this.mouseX = 0;
        this.eventHandler = this.handleEvent.bind(this);
        this.updateUser = this.updateUserType.bind(this);

    }

    updateUserType() {
        this.setState({"userType": UserTypeStorage.getUserType()});
    }

    /**
     * Panel controls for when panel is half-open
     * @param {boolean} isOpen If true, slide open the panel; close otherwise
     */
    initPanelRight(isOpen) {
        setTimeout(() => {
            $("#right-panels").css("right", (isOpen) ? "0" : "-500px");
        }, 50);
    }

    showPropertyPanel() {
        // Prevent opening in canvas if property panel is embeded in other UI.
        if(this.props.embed){
            return;
        }
        const panel = this.props.panelDOM || $("#property_panel");
        panel.removeClass("app-component")

        if (!this.props.embed) {
            if (this.props.context.hasWriteProxy && !this.props.context.hasWriteProxy() && this.props.node.props.readOnly) {
                this.props.context.readOnly = true;
            }
            if (this.props.context.hasWriteProxy && !this.props.context.hasWriteProxy() && this.props.node.props.isCommonModule) {
                this.props.context.isCommonModule = true;
            }
        }

        if (!this.props.context.props.nodeTypeName && this.props.context.props.nodeTypeName === "Module Begin") {
            this.setState({ isOpen: false });
        } else {
            this.setState({ shouldHover: false });
            this.setState({ isOpen: true });
        }

        $("#right-panels").css("right", "0px").show();
    }

    resetCommonModuleVersionsDropdown() {
        this.setState({ commonModuleVersionsOptions: [{ name: 'Loading...', value: 'Loading...' }] });
        this.setState({ commonModuleSelectedVersion: 0 });
    }

    /**
     * Update view upon event
     * @param {Object} event Document CustomEvent
     */
    handleEvent(event) {
        if (event.type === "ev-property-refresh") {
            if (this.props.onChange) { this.props.onChange(this.props.context) }
            window.apm.postEventToCurrentView(
                {
                    target: "request-node-property-panel",
                    event: { node: this.props.context }
                }
            );
        }
    }

    handleClickOutside = () => {
        if(this.props.closeOnClickOutside) {
            Utility.hidePropertyPanel();
            this.props?.onClose?.();
        }
    ;}

    componentDidMount() {
        if (this.props.context === null) {
            return null;
        }

        if (this.props.context.props.nodeTypeName === "Task Orchestration Node") {
            this.setFormsList();
        }

        document.addEventListener("ev-property-refresh", this.eventHandler);
        document.addEventListener('ev-update-userType', this.updateUser);

        $("#right-panels").onResize({
          localStorageId: "resize:right-panels",
          maxSize: 500,
          minSize: 220,
          side: "right"
        });

        if (this.props.context.props.isCommonModule && this.props.context.props.isRootModule) {
            this.setCommonModuleVersionOptionsState(this.props);
        }

        this.showPropertyPanel();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.context.props.isCommonModule && nextProps.context.props.isRootModule) {
            this.setCommonModuleVersionOptionsState(nextProps);
        }

        if (nextProps.context.props.nodeTypeName === "Task Orchestration Node") {
            this.setFormsList();
        }
    }

    componentWillUnmount() {
        document.removeEventListener("ev-property-refresh", this.eventHandler);
        document.removeEventListener('ev-update-userType', this.updateUser);
        $("#right-panels").offResize();
    }

    setFormsList() {
        window.colm.requestFormList((res) => {
            if (res) {
                const forms = {};
                if (res && res[0]) {
                    res.forEach((form) => {
                        if (forms[form.name]) {
                            forms[form.name].push({
                                name: form.version,
                                value: form.version,
                            });
                        } else {
                            forms[form.name] = [{
                                name: form.version,
                                value: form.version,
                            }];
                        }
                    });
                    this.setState({
                        formsList: forms,
                        uniqueFormsList: Object.keys(forms).map((formName) => {
                            return {
                                name: formName,
                                value: formName,
                            }
                        }),
                    })
                }
            }
        });
    }

    async setCommonModuleVersionOptionsState(props) {
        // application-level mod
        if (props.context.id === props.context.props.parentComponentID) {
            this.resetCommonModuleVersionsDropdown();
            const currentVersion = props.context.props.config.version;
            const cm = window.apm.serialized.components.modules.find(mod => mod.id === props.context.id);
            const commonBranch = await avsService.getCommonModuleMainBranchByDesignName(
                cm.repoName
            );
            const options = (!commonBranch) ? [] : (
                await avsService.getVersions(commonBranch.id)
            ).map(({ version }) => {
                return {
                    name: version,
                    value: version
                }
            });
            if (!options.length) {
                errorMessageService.addError({
                    message: 'Unable to find common module. Please contact the dev team for support.',
                    type: ErrorMessageType.error
                });
            }

            this.setState({commonModuleVersionsOptions: options});
            this.setState({commonModuleSelectedVersion: options.findIndex(opt => opt.value === currentVersion)});
        } else {
            // instance mod
            const { version } = props.context.props.config;
            const options = [{name: version, value: version}];
            this.setState({commonModuleVersionsOptions: options});
            this.setState({commonModuleSelectedVersion: 0});
        }
    }

    hasPermissionTab() {
        return this.props.context instanceof ModuleNodeModel;
    }

    /**
     * Render title tabs
     * @returns {XML}
     */
    renderTitle() {
        const isLocal = this.props.context.id !== this.props.context.props.parentComponentID;

        return (
            <div key={this.props.context.getID() + "-title"} className="panel_title">
                {!isLocal && this.props.context.hasWriteProxy() &&
                    <div className="app-comp">
                        <div><span style={{ padding: '2px 6px', backgroundColor: "var(--color-background)" }}>{window.l.property.application_component}</span></div>
                    </div>
                }
                {isLocal &&
                    <div id="rfd" className="app-comp">
                        <div><span style={{ padding: '2px 6px', backgroundColor: "var(--color-background)" }}>{window.l.property.local_component}</span></div>
                    </div>
                }

                {/* TODO: add permission tab with Oauth */}
                {/* <ul className="nav nav-tabs">
                    <li className="nav-button active theme-main primary tint">
                        <a data-toggle="tab" href="#property_panel_props">{window.l.property.property}</a>
                    </li>
                    {this.hasPermissionTab() && [
                        <div key="permission_break" className="break">&nbsp;</div>,
                        <li key="permission_tab" className="nav-button theme-main primary tint">
                            <a data-toggle="tab" href="#property_panel_perms">{window.l.property.permission}</a>
                        </li>
                    ]}
                </ul> */}

            </div>
        );
    }

    /**
     * Render node type name
     * @returns {XML}
     */
    renderNodeType() {
        const { context } = this.props;
        const commonModulePrefix = (!context.props.isCommonModule) ? '' : (
            `${context.props.moduleApp} - `
        );
        const nodeTypeName = context.nodeTypeName?.() || context.getProperty("nodeTypeName");

        return (
            <label className="node-type-name">
                <i className={`fe icon-${getModelIcon(context)}`} />
                {commonModulePrefix}
                {nodeTypeName}
            </label>
        );
    }

    /**
     * Render common module label for sensitive override property
     * @param {object} hasSensitiveOverrides
     * @returns {XML}
     */
    redactedLabel(sensitiveOverrides) {
        const sensitiveOverridesEnabled = sensitiveOverrides.enabled || false;

        if (sensitiveOverridesEnabled) {
            return (
                <label className="node-type-name" style={{ color: "var(--color-error)", marginLeft: "8px" }}>
                    <i className="fe icon-alert-triangle"></i>Sensitive Override Enabled
                </label>
            );
        }
        return null;
    }

    renderNodeLastEdited() {
        const { author, lastLocalChange } = this.props.context.props;

        const savedDateTime = lastLocalChange && new Date(lastLocalChange).toLocaleString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
        const savedTimeAgo = lastLocalChange && formatTimeSince(lastLocalChange);

        return (
            <div className="last-edit">
                {!!lastLocalChange && <div>
                    Last Edit: <span className="date">{savedDateTime}</span> ({savedTimeAgo})
                </div>}
                {!!author && (
                    <div>
                        By:{' '}
                        <span className="author" title={author}>
                            {window.apm.getDesignerAuthor() === author ? 'you' : author}
                        </span>
                    </div>
                )}
                <hr />
            </div>
        );
    }

    getValidUser(viewConfig) {
        const hasUserType = viewConfig.userType && viewConfig.userType.length > 0;
        const isValidUserType = hasUserType ? viewConfig.userType.indexOf(this.state.userType) !== -1 : false;
        return !hasUserType || (hasUserType && isValidUserType);
    }

    getInputDisabledProp(viewConfig, isCommonModule) {
        const isReadOnly = this.props.context.readOnly;
        const hasLockNameEnabled = (viewConfig.key === "name" && this.props.context.props.config.lockName);
        const isDisabled = viewConfig.disabled;
        const isAnalystClass = viewConfig.key === "analystClass";

        if (isAnalystClass && isCommonModule) {
            return false;
        }

        return isReadOnly || isCommonModule || hasLockNameEnabled || isDisabled;
    }

    /**
     * Render property views
     * @returns {XML}
     */
    renderContent() {
        const isCommonModule = this.props.context.props.isCommonModule;
        /** @type {import("../types").ConfigView[]} */
        const configViews = this.props.context.getConfigViews(this.props.configViewType || 'default', isCommonModule);
        const sensitiveOverrides = this.props.context.props.config?.sensitiveOverrides || false;

        if (React.isValidElement(configViews)) {
            return configViews;
        }

        return (
            <div onScroll={() => this.handleScroll()} key={this.props.context.getID() + "-content"} id="property_panel_props"
                className={"tab-pane fade in active container" + (this.props.embed ? " embed" : "")}
            >
                {!this.props.embed && this.renderNodeType()}
                {sensitiveOverrides && this.redactedLabel(sensitiveOverrides)}
                {!this.props.embed && this.renderNodeLastEdited()}
                {(() => {
                    var views = [];
                    for (var i = 0; i < configViews.length; i++) {
                        const v = configViews[i];
                        if (v === null) {
                            continue;
                        } else if (React.isValidElement(v)) {
                            views.push(v);
                            continue;
                        } else if (typeof v === "function") {
                            views.push(v());
                            continue;
                        }
                        const context = 'context' in v ? v.context : this.props.context;
                        const compKey = this.props.context.getID() + "-" + i;
                        const isCommonModule = (this.props.embed) ? false : this.props.node.props.isCommonModule;
                        const isInstanceContext = (!this.props.context.props.parentComponentID) ? false : this.props.context.props.parentComponentID !== this.props.context.id;
                        const hint = v.hasOwnProperty("hint") ? v.hint : "";
                        const valRules = v.hasOwnProperty("valRules") ? v.valRules : {};

                        switch (v.type) {
                            case "Boolean":
                                views.push(<label key={compKey}>{v.label + ": " + (context.getConfig(v.key) ? v.yes : v.no)}</label>);
                                break;
                            case "Input":
                                const inputRules = v.hasOwnProperty("inputRules") ? v.inputRules : {};
                                views.push(<Input
                                    label={v.label}
                                    hint={hint}
                                    context={context}
                                    valKey={v.key}
                                    value={context.getConfig(v.key)}
                                    valRules={valRules}
                                    inputRules={inputRules}
                                    isHidden={v.isHidden}
                                    suggestion={v.suggestion}
                                    key={compKey}
                                    disabled={this.getInputDisabledProp(v, isCommonModule)}
                                    tooltip={v.tooltip}
                                    toolBarNode={this.props.toolBarNode}
                                    isPropertyPanel={true}
                                    suppressUpdate={v.suppressUpdate}
                                    excludeSensitiveVariables={v.excludeSensitiveVariables || false}
                                    skipOnBlur={v.skipOnBlur}
                                    suggestionList={v.suggestionList}
                                />);
                                break;
                            case "ItemList":
                                if (this.getValidUser(v)) {
                                    views.push(this.getItemList(context, v, compKey));
                                }
                                break;
                            case ConfigViewType.jsx: {
                                views.push(
                                    <FormField label={v.label} tooltip={v.tooltip}>
                                        {v.content}
                                    </FormField>
                                );
                                break;
                            }
                            case "Label":
                                views.push(this.getLabel(v));
                                break;
                            case "WrappedItemList":
                                views.push(<VisibilityWrapper key={compKey + "-" + "VisibilityWrapper"} context={context} hideKey={v.hideKey}>{this.getItemList(context, v, compKey)}</VisibilityWrapper>);
                                break;
                            case "TagList":
                                views.push(<TagList label={v.label} view={v.view}
                                    context={context} valKey={v.key} value={context.getConfig(v.key)}
                                    key={compKey} />);
                                break;
                            case "Textarea":
                                if (v.key)
                                    views.push(<Textarea label={v.label}
                                        tooltip={v.tooltip}
                                        context={context}
                                        valKey={v.key}
                                        value={context.getConfig(v.key)}
                                        highlight={v.highlight}
                                        key={compKey} readOnly={v.readOnly || isCommonModule}
                                        valRules={valRules}
                                        rows={(v.rows) ? v.rows : 5}
                                        suppressUpdate={v.suppressUpdate}
                                        isPropertyPanel={true}
                                    />);
                                break;
                            case "PromptTextarea":
                                const textValue = context.props.nodeTypeName === "Save Prompt" ? context.getConfig(v.key) : v.value;
                                views.push(
                                    <PromptTextarea
                                        context={context}
                                        hideLabel={v.hideLabel}
                                        valKey={v.key}
                                        value={textValue}
                                        lang={v.lang}
                                        key={compKey}
                                        readOnly={v.readOnly}
                                        suppressUpdate={v.suppressUpdate}
                                        isPropertyPanel={true}
                                    />);
                                break;
                            case "KeySwitch":

                                views.push(
                                    <KeySwitch
                                        context={context}
                                        valKey={v.key}
                                        value={context.getConfig(v.key)}
                                        key={compKey}
                                        label={v.label}
                                        readOnly={v.readOnly || isCommonModule}
                                        suppressUpdate={v.suppressUpdate} />);
                                break;
                            case "Condition":
                                if (this.getValidUser(v)) {
                                    views.push(<Condition
                                        context={context}
                                        valKey={v.key}
                                        value={context.getConfig(v.key)}
                                        key={compKey}
                                        readOnly={v.readOnly || isCommonModule}
                                        suppressUpdate={v.suppressUpdate}
                                    />);
                                }
                                break;
                            case "hr":
                                views.push(<hr key={compKey} />);
                                break;
                            case "Button":
                                if (v.label === "View Query / Mutation") {
                                    views.push(<Button context={context}
                                        label={v.label} desc={v.desc} type={v.class} wide={v.wide}
                                        callback={v.callback}
                                        key={compKey} disabled={false}
                                        suppressUpdate={v.suppressUpdate} />);
                                } else {
                                    views.push(<Button context={context}
                                        label={v.label} desc={v.desc} type={v.class} wide={v.wide}
                                        callback={v.callback}
                                        key={compKey}
                                        disabled={v.readOnly || isCommonModule}
                                        suppressUpdate={v.suppressUpdate}
                                    />);
                                }
                                break;
                            case "KeyValue":
                                //module input
                                if (context.type === "module") {
                                    views.push(<KeyValue context={context} inputIndex={v.inputIndex}
                                        label={v.label} variableName={v.variableName} layout={v.layout} valKey={"inputs"} value={v.pair}
                                        pairKeyView={v.pairKeyView} pairValueView={v.pairValueView} key={compKey}
                                        disabled={v.readOnly || isCommonModule}
                                        suppressUpdate={v.suppressUpdate}
                                    />);
                                }
                                else {
                                    const value = context.getConfig(v.key) ? context.getConfig(v.key) : {};
                                    views.push(<KeyValue
                                        context={context}
                                        label={v.label}
                                        valKey={v.key}
                                        value={value}
                                        pairKeyView={v.pairKeyView}
                                        pairValueView={v.pairValueView}
                                        key={compKey}
                                        disabled={v.readOnly || isCommonModule}
                                        suppressUpdate={v.suppressUpdate} />);
                                }

                                break;
                            case "NestedProperties":
                                const value = context.getConfig(v.key) ? context.getConfig(v.key) : {};
                                views.push(<NestedProperties
                                    context={context}
                                    label={v.label}
                                    valKey={v.key}
                                    value={value}
                                    nestedProps={v.nestedProps}
                                    key={compKey}
                                    disabled={v.readOnly || isCommonModule}
                                    suppressUpdate={v.suppressUpdate} />);
                                break;

                            case "Dropdown":
                                var sel = -1;
                                if (v.hasOwnProperty("sel")) {
                                    sel = v.sel;
                                } else {
                                    const val = context.getConfig(v.key) ? context.getConfig(v.key) : "";
                                    v.options.forEach((opt, i) => {
                                        if (opt.value === val) {
                                            sel = i;
                                        }
                                    });
                                }

                                // check for userType before pushing  
                                if (this.getValidUser(v)) {
                                    views.push(<Dropdown context={context} label={v.label} optionName={v.optionName}
                                        options={v.options} valKey={v.key} selection={sel} tooltip={v.tooltip}
                                        key={compKey} removable={v.removable}
                                        readOnly={v.readOnly ?? isCommonModule}
                                        suppressUpdate={v.suppressUpdate} />);
                                }
                                break;

                            case "IntentDropdown":
                                var sel = -1;
                                var options = window.apm.knowledgeBase.getIntents();

                                if (v.hasOwnProperty("sel")) {
                                    sel = v.sel;
                                } else {
                                    const val = context.getConfig(v.key) ? context.getConfig(v.key) : "";
                                    for (var ds = 0; ds < options.length; ds++) {
                                        if (options[ds].value === val) {
                                            sel = ds;
                                            break;
                                        }
                                    }
                                }

                                views.push(<IntentDropdown
                                    context={context}
                                    label={v.label}
                                    optionName={v.optionName}
                                    removable={v.removable}
                                    options={options}
                                    valKey={v.key}
                                    selection={sel}
                                    key={compKey}
                                    readOnly={v.readOnly || isCommonModule}
                                    tooltip={v.tooltip}
                                    suppressUpdate={v.suppressUpdate} />);
                                break;
                            case "DtmfDropDown":
                                var sel = -1;
                                let localIntents;
                                var dtmfIntents = [];
                                let intent;
                                if (context.props.config.localIntents) {
                                    localIntents = context.props.config.localIntents;
                                    if (!this.props.context.readOnly) {
                                        intent = window.apm.knowledgeBase.getIntents();
                                    }
                                    else {
                                        for (let i = 0; i < window.apm.serialized.appCommonModules.length; i++) {
                                            if (this.props.context.props.moduleApp === window.apm.serialized.appCommonModules[i].application) {
                                                intent = window.apm.knowledgeBase.getCommonModuleIntents(window.apm.serialized.appCommonModules[i]);
                                            }
                                        }
                                    }
                                    for (let l = 0; l < localIntents.length; l++) {
                                        var hj = _.filter(intent, { value: localIntents[l] });
                                        if (hj.length > 0) {
                                            dtmfIntents.push(hj[0]);
                                        }
                                    }
                                }
                                else {
                                    let localIntents = [];
                                }
                                if (v.hasOwnProperty("sel")) {
                                    sel = v.sel;
                                } else {
                                    const val = context.getConfig(v.key) ? context.getConfig(v.key) : "";
                                    for (var ds = 0; ds < dtmfIntents.length; ds++) {
                                        if (dtmfIntents[ds].value === val) {
                                            sel = ds;
                                            break;
                                        }
                                    }
                                }
                                views.push(<Dropdown context={context} label={v.label} optionName={v.optionName}
                                    removable={v.removable} tooltip={v.tooltip}
                                    options={dtmfIntents} valKey={v.key} selection={sel}
                                    key={compKey} readOnly={v.readOnly || isCommonModule}
                                    suppressUpdate={v.suppressUpdate} />);
                                break;
                            case "PromptDropdown":
                                var sel = -1;
                                let promptOptions = window.apm.knowledgeBase.getPrompts();


                                const val = context.getConfig(v.key) ? context.getConfig(v.key) : "";
                                for (var ds = 0; ds < promptOptions.length; ds++) {
                                    if (promptOptions[ds].value === val) {
                                        sel = ds;
                                        break;
                                    }
                                }
                                views.push(<Dropdown context={context} label={v.label} optionName={v.optionName}
                                    options={promptOptions} valKey={v.key} selection={sel} tooltip={v.tooltip}
                                    key={compKey} readOnly={v.readOnly || isCommonModule}
                                    suppressUpdate={v.suppressUpdate} />);
                                break;
                            case "PlavSavedPromptKeyDropdown":
                                var sel = -1;
                                let palySavedPromptOptions = window.apm.knowledgeBase.getPlaySavedPrompts();


                                const valK = context.getConfig(v.key) ? context.getConfig(v.key) : "";
                                var keys = [];
                                for (var pk = 0; pk < palySavedPromptOptions.length; pk++) {
                                    if (palySavedPromptOptions[pk].value === valK) {
                                        sel = pk;
                                        break;
                                    }
                                }
                                views.push(<Dropdown context={context} label={v.label} optionName={v.optionName}
                                    options={palySavedPromptOptions} valKey={v.key} selection={sel} tooltip={v.tooltip}
                                    key={compKey} readOnly={v.readOnly || isCommonModule}
                                    suppressUpdate={v.suppressUpdate} />);
                                break;
                            case "ModuleParamDropdown":
                                var sef = -1;
                                var moduleParamDropDown = [];
                                if (window.apm.serialized.parameters && Utility.getIsCommonModule(window.apm.serialized) && !window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule) {
                                    for (var gh = 0; gh < window.apm.serialized.parameters.length; gh++) {
                                        if (window.apm.serialized.parameters[gh].type === "MODULE") {
                                            moduleParamDropDown.push({ value: window.apm.serialized.parameters[gh].varName, name: window.apm.serialized.parameters[gh].varName })
                                        }
                                    }
                                }
                                if (Utility.getIsCommonModule(window.apm.serialized) && window.apm.getCurrentDiagramWidget().props.node.props.isCommonModule && context.hasWriteProxy && !context.hasWriteProxy()) {
                                    moduleParamDropDown = window.apm.knowledgeBase.getModules();

                                }
                                if (!Utility.getIsCommonModule(window.apm.serialized)) {
                                    moduleParamDropDown = window.apm.knowledgeBase.getModules();

                                }
                                const valP = context.getConfig(v.key) ? context.getConfig(v.key) : "";
                                var keys = [];
                                for (var mp = 0; mp < moduleParamDropDown.length; mp++) {
                                    if (moduleParamDropDown[mp].value === valP) {
                                        sef = mp;
                                        break;
                                    }
                                }


                                views.push(<Dropdown context={context} label={v.label} optionName={v.optionName}
                                    options={moduleParamDropDown} valKey={v.key} selection={sef} tooltip={v.tooltip}
                                    key={compKey}
                                    suppressUpdate={v.suppressUpdate} />);
                                break;
                            case "FormListDropDown":
                                let selectedForm = context.getConfig(v.key) ? context.getConfig(v.key) : "";
                                views.push(
                                    <Dropdown
                                        context={context}
                                        key={compKey}
                                        label={v.label}
                                        optionName={v.optionName}
                                        options={this.state.uniqueFormsList}
                                        valKey={v.key}
                                        selection={this.state.uniqueFormsList.findIndex((option) => option.value === selectedForm)}
                                        tooltip={v.tooltip}
                                        readOnly={v.readOnly}
                                        suppressUpdate={v.suppressUpdate}
                                    />);
                                break;
                            case "FormVersionsDropDown":
                                selectedForm = context.getConfig("formName") ? context.getConfig("formName") : "";
                                if (this.state.formsList && Object.keys(this.state.formsList).length && selectedForm) {
                                    const selectedFormVersion = context.getConfig(v.key) !== -1 ? context.getConfig(v.key) : "";
                                    views.push(
                                        <Dropdown
                                            context={context}
                                            key={compKey}
                                            clearSelection={selectedFormVersion ? false : true}
                                            label={v.label}
                                            optionName={v.optionName}
                                            options={this.state.formsList[selectedForm]}
                                            valKey={v.key}
                                            selection={this.state.formsList[selectedForm].findIndex((option) => option.value === selectedFormVersion)}
                                            tooltip={v.tooltip}
                                            readOnly={v.readOnly}
                                            suppressUpdate={v.suppressUpdate}
                                        />);
                                }
                                break;
                            case "CommonModuleVersionDropDown":
                                const isSelfContext = this.props.context.id === this.props.node.id;

                                views.push(
                                    <Dropdown
                                        context={context}
                                        isCommonModuleVersionDropdown={true}
                                        popupFunc={v.popupFunc}
                                        label={v.label}
                                        optionName={v.optionName}
                                        options={this.state.commonModuleVersionsOptions}
                                        valKey={v.key}
                                        selection={this.state.commonModuleSelectedVersion}
                                        tooltip={v.tooltip}
                                        key={compKey}
                                        readOnly={v.readOnly || isSelfContext || isInstanceContext}
                                        suppressUpdate={v.suppressUpdate}
                                    />);
                                break;
                            case "Switch":
                                // TODO: move this logic up into props

                                const checked = v.key === 'moduleInput' && this.props.isLocalVar || context.getConfig(v.key);
                                if (this.getValidUser(v)) {
                                    views.push(<Switch
                                        context={context}
                                        label={v.label}
                                        tooltip={v.tooltip}
                                        valKey={v.key}
                                        checked={checked}
                                        key={compKey}
                                        disabled={this.props.context.readOnly || v.disabled || isCommonModule}
                                        toggledLabel={v.toggledLabel}
                                        broadcast={v.broadcast}
                                        callback={v.callback}
                                        suppressUpdate={v.suppressUpdate} />);
                                }
                                break;
                            case "Function":
                                if (this.getValidUser(v)) {
                                    views.push(<FunctionComponent
                                        context={context}
                                        functionType={v.functionType}
                                        valKey={v.key}
                                        value={context.getConfig(v.key)}
                                        key={compKey}
                                        disabled={this.props.context.readOnly || isCommonModule}
                                        suppressUpdate={v.suppressUpdate} />);
                                }
                                break;
                            case "ScopeHint":
                                if (this.getValidUser(v)) {
                                    views.push(<ScopeHint link={v.link} key={compKey} />);
                                }
                                break;
                            case "ExitComponent":
                                views.push(<ExitComponent context={context} exitHandling={v.exitHandling}
                                    valKey={v.key} value={context.getConfig(v.key)}
                                    key={compKey} readOnly={this.props.context.readOnly || isCommonModule} />);
                                break;
                            case "Slider":
                                views.push(<BasicSlider
                                    context={context}
                                    valKey={v.key}
                                    label={v.label}
                                    min={v.min}
                                    max={v.max}
                                    value={context.getConfig(v.key)}
                                    key={compKey}
                                    enabled={context.getConfig(v.enabledKey) || !isCommonModule}
                                    labelSuffix={v.labelSuffix}
                                    suppressUpdate={v.suppressUpdate}
                                />);
                                break;
                        }
                    }
                    return views.map((view, i) => ({...view, key: view?.key || i}));
                })()}
            </div>
        );
    }

    /**
     * Render permission views
     * @returns {XML}
     */
    renderPermission() {
        const permission = this.props.context.getPermission(window.colm.user.userGroup);
        var permissionString;
        if (permission.write) {
            permissionString = window.l.property.have_read_write_access;
        } else if (permission.read) {
            permissionString = window.l.property.have_read_access;
        } else {
            permissionString = window.l.property.have_no_access;
        }

        return (
            <div key={this.props.context.getID() + "-permission"} id="property_panel_perms"
                className="tab-pane fade container"
            >
                <div className={"node-type-name dark"}><i className={"fe icon-user-check"} />
                    {permissionString}
                </div>
                <hr />
                {(() => {
                    const permissions = this.props.context.getPermissions();
                    const groups = Constant.k.USER_GROUP;
                    const currentGroup = groups[window.colm.user.userGroup];
                    var views = [];
                    for (var key in groups) {
                        if (groups.hasOwnProperty(key)) {
                            const compKey = this.props.context.getID() + "-" + key;
                            var canEdit = groups[key].accessLevel < currentGroup.accessLevel;
                            if (!permission.write) {
                                canEdit = false;
                            }
                            views.push(<GroupPermission context={this.props.context}
                                label={groups[key].name}
                                canEdit={canEdit}
                                valKey={key} value={permissions[key]}
                                key={compKey} />);
                        }
                    }
                    return views;
                })()}
            </div>
        );
    }

    handleScroll = () => {
        const scrollContainer = document.getElementById(scrollContainerId);
        if (this.state.saveScrollPosition && scrollContainer) {
            this.state.scrollPosition = scrollContainer.scrollTop;
        } else if (!this.state.saveScrollPosition) {
            scrollContainer.scrollTop = this.state.scrollPosition;
        }
    };

    componentDidUpdate() {
        this.state.saveScrollPosition = false;
        requestAnimationFrame(() => {
            this.state.saveScrollPosition = true;
        });
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        if (this.props.context === null) {
            return null;
        }
        if (this.props.embed) {
            return (
                <div className="content-wrapper">
                    {this.renderContent()}
                </div>
            );
        }
        return (
            <ClickOutside
                className="content-wrapper"
                excludeElements={this.props?.excludeOnClickOutside}
                onClickOutside={this.handleClickOutside}
            >
                {this.renderTitle()}
                <div className="tab-content clearfix">
                    {this.renderContent()}
                    {this.hasPermissionTab() && this.renderPermission()}
                </div>
            </ClickOutside>
        );
    }
    getLabel(v) {
        if (v.labelName === "Additional Condition") {
            return <div> <label key={v.key} style={{ paddingTop: '20px', fontSize: '14px', fontStyle: "bold" }}>{v.labelName}</label></div>
        }
        return <div ><label key={v.key}>{v.labelName}</label><br></br></div>
    }
    getItemList(context, v, compKey) {

        return <ItemList
            label={v.label}
            tooltip={v.tooltip}
            view={v.view}
            context={context}
            valKey={v.key}
            value={context.getConfig(v.key)}
            options={v.options}
            pairKeyView={v.pairKeyView}
            pairValueView={v.pairValueView}
            updateOnly={v.updateOnly}
            icon={v.icon}
            allowDelete={v.allowDelete}
            menuType={v.menuType}
            key={compKey}
            readOnly={v.readOnly || this.props.context.readOnly || (this.props.node && this.props.node.props.isCommonModule)}
            callback={v.callback || null}
            suppressUpdate={v.suppressUpdate} />;
    }
}
